<template>

<div>

  <LDBsTable
    url="system-module"
    defaultSort="name"
    defaultOrder="asc"
    :query="query"
    :columns="columns"
    :clear="clear"
    :defaultOptions='options'
  >
    <div class="form-group col-lg-6">
      <label>{{ $t('name') }}</label>
      <input
        type="text"
        class="form-control"
        id="name"
        name="name"
        :placeholder="$t('type_name')"
        v-model="query.name"
      >
    </div>

    <div class="form-group col-lg-6">
      <label>{{ $t('tag') }}</label>
      <input
        type="text"
        class="form-control"
        id="tag"
        name="tag"
        :placeholder="$t('type_tag')"
        v-model="query.tag"
      >
    </div>
  </LDBsTable>

</div>

</template>

<script>
import LDBsTable from '@/components/shared/LDBsTable'

export default {
  name: 'SystemModulesList',
  components: {
    LDBsTable
  },
  data () {
    return {
      columns: [
        {
          title: this.$t('name'),
          field: 'name',
          sortable: true
        },
        {
          title: this.$t('tag'),
          field: 'tag',
          sortable: true
        },
        {
          key: 'id',
          field: 'id',
          align: 'center',
          width: '100%',
          formatter: function (value) {
            return `<a href="#/main/system-modules/${value}" class="edit btn btn-action btn-primary btn-circle light-bottom-shadow text-white"><i class="fas fa-pen"></i></a>`
          },
        }
      ],
      options: {
        exportOptions: { fileName: 'modulos' }
      },
      query: {
        id: '',
        name: '',
        tag: ''
      }
    }
  },
  methods: {
    clear() {
      this.query.name = '',
      this.query.tag = ''
    }
  }
}

</script>
